import * as React from 'react'

const MOBILE_WIDTH = 768

const isMobile = () => window.innerWidth <= MOBILE_WIDTH

/**
 * Monitors the window width and returns whether or not we are under the mobile
 * breakpoint width (768 px). The main purpose of using this hook is to trigger
 * re-renders when the width crosses the mobile width threshold.
 */
export const useMobileScreen = (): boolean => {
  const [isMobileScreen, setIsMobileScreen] = React.useState(isMobile())

  React.useEffect(() => {
    // Since our state is a primitive value, setting it to the same value won't
    // trigger a re-render.
    const handleResize = () => setIsMobileScreen(isMobile())
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return isMobileScreen
}
